export const CREATE_DOCUMENT = 'Dyzio/DocumentUpload/CREATE_DOCUMENT';



/** WEBPACK FOOTER **
 ** ./src/containers/document-upload-modal/constants.js
 **/